module.exports = __webpack_public_path__ + "static/media/warningIcon.0fb16fd0.svg";